module.exports = __webpack_public_path__ + "img/install-lp-icon.b81275ed.svg";